module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("2")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("International Petroleum Contracts"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-369"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-369"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("A")]), _vm._v("fter an area with potential has been identified, if it has not already done so, the oil and gas producer must acquire the right")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-370"
    }
  }, [_vm._v(" to explore, develop, and produce any minerals that might exist in the area. This is accomplished by identifying the party(ies) who own the mineral right")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-371"
    }
  }, [_vm._v("s or who are entrusted with the authority to enter into contracts for the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-372"
    }
  }, [_vm._v(" and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-373"
    }
  }, [_vm._v(" of minerals in the area. The type of contract and individual contract terms executed in any given location depend on local laws and fiscal policies governing mineral ownership and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-374"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-374"
    }
  }, [_vm._v("In most countries, ownership of mineral")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-375"
    }
  }, [_vm._v(" rights rests with the government. The U.S. is one of a handful of countries where individuals and institutions can own mineral rights although the federal and state governments may also own mineral rights. In order for an E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-376"
    }
  }, [_vm._v(" company to obtain access to mineral rights on private lands they must contract with individual or corporate owners. In order for an E&P company to obtain access to mineral rights owned by federal or state governments they must negotiate an agreement with federal agencies such as the Bureau of Land Management or the Mineral Management Service or with the agency charged with oversight of mineral rights owned by the individual state.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-376"
    }
  }, [_vm._v("In most countries, laws governing ownership and development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-377"
    }
  }, [_vm._v(" of oil and gas mineral rights are established at the federal government level. Laws and regulations related to exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-378"
    }
  }, [_vm._v(", development, and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-379"
    }
  }, [_vm._v(" of mineral resources, including oil and gas, have evolved over time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-380"
    }
  }, [_vm._v(" and typically involve some combination of royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-381"
    }
  }, [_vm._v(", taxes, fees, or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-382"
    }
  }, [_vm._v("/profit sharing. Petroleum systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-383"
    }
  }, [_vm._v(" are often classified as being fundamentally either tax/royalty or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-384"
    }
  }, [_vm._v("/profit sharing systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-385"
    }
  }, [_vm._v(". In tax/royalty systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-386"
    }
  }, [_vm._v(" the ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-387"
    }
  }, [_vm._v(" of the oil and gas reserves typically passes to the contractor (E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-388"
    }
  }, [_vm._v(" company) prior to the point of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-389"
    }
  }, [_vm._v(" (i.e., upstream from the wellhead) while in production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-390"
    }
  }, [_vm._v("/profit sharing systems ownership of oil and gas does not pass to the contractor until after it has been severed from the earth (i.e., downstream of the wellhead).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-390"
    }
  }, [_vm._v("The types of contracts observed in various petroleum systems are illustrated in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#Fig2-1"
    }
  }, [_vm._v("Figure 2-1")]), _vm._v(". Leases"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-391"
    }
  }, [_vm._v(" and concession agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-392"
    }
  }, [_vm._v(" are common to tax/royalty systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-393"
    }
  }, [_vm._v(" while production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-394"
    }
  }, [_vm._v(" sharing contracts and service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-395"
    }
  }, [_vm._v(" are examples of contracts utilized in production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-396"
    }
  }, [_vm._v("/profit sharing based systems. This chapter discusses four of the most common types of contracts encountered in worldwide oil and gas "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("operations. These contracts are: leases, concession agreements, production")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-397"
    }
  }, [_vm._v(" sharing contracts (or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-398"
    }
  }, [_vm._v(" sharing agreements), and risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-399"
    }
  }, [_vm._v(". While any given type of contracts has common provisions and features, the individual terms of any specific contract will likely vary since each contract results from negotiations between the various parties involved.")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "Fig2-1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-399"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration. Fig. 2-1. Petroleum Systems",
      "src": "images/Fig2-1.jpg"
    }
  })])]), _c('div', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-399"
    }
  }, [_c('b', [_vm._v("Fig. 2-1.")]), _vm._v(" Petroleum Systems")])])]), _c('div', {
    staticClass: "fig_source"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-399"
    }
  }, [_c('i', [_vm._v("Source:")]), _vm._v(" Adapted from Daniel Johnston: "), _c('i', [_vm._v("International Petroleum Fiscal Systems and Production Sharing Contracts")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-400"
    }
  })])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-400"
    }
  }, [_vm._v("Tax/Royalty Systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-401"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-401"
    }
  }, [_vm._v("Since in most countries rights to all minerals under the earth’s surface are owned and controlled by the government, an E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-402"
    }
  }, [_vm._v(" company seeking to acquire a working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-403"
    }
  }, [_vm._v(" in a particular country therefore must normally enter into a contract with the government of that country. (The foreign E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-404"
    }
  }, [_vm._v(" company or companies that enter into the contract are often referred to as the contractor. Note that the term contractor, which is singular, may be used to refer to one or more companies.) Countries where the government owns the rights to the minerals but where ownership of oil and gas can be transferred to the contractor are referred to as having"), _c('b', [_vm._v(" tax/royalty systems")])]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-405"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-405"
    }
  }, [_vm._v(", and the oil and gas contract is typically referred to as a lease but may also be called a"), _c('b', [_vm._v("vlicense")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-406"
    }
  }, [_vm._v(" or "), _c('b', [_vm._v("concession agreement")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-407"
    }
  }, [_vm._v(".")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-408"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-408"
    }
  }, [_vm._v("Under a tax/royalty system, the legal title to or ownership of hydrocarbon minerals passes to the contractor while the minerals are in the ground. Often the legal title to production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-409"
    }
  }, [_vm._v(" equipment that is permanently affixed to the surface passes to the state at the end of the contract period; however, the contractor is typically responsible for abandonment and reclamation costs.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-409"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  })]), _c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-409"
    }
  }, [_vm._v("Lease Agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-410"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-410"
    }
  }, [_vm._v("In the U.S. the most common form of agreement between a mineral rights owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-411"
    }
  }, [_vm._v(" and the E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-412"
    }
  }, [_vm._v(" companies seeking to obtain access to the minerals is a lease agreement. An individual, institution, federal or state government, or other entity may own the mineral right")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-413"
    }
  }, [_vm._v("s to a property and convey the mineral rights to an E&P company by executing a lease agreement. In the U.S. there are numerous properties, many that are very small, and often there are multiple parties owning the mineral rights for any given property. Consequently, the U.S. is characterized by numerous, small-acreage leases. When the lease agreement is executed between the mineral rights owner(s) and the oil and gas company(ies), two types of interest are created: a royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-414"
    }
  }, [_vm._v(" and a working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-415"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-415"
    }
  }, [_vm._v("When multiple parties own mineral rights in a property, the mineral rights are referred to as"), _c('b', [_vm._v(" undivided")]), _vm._v(" interests. An undivided interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-416"
    }
  }, [_vm._v(" exists when multiple mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-417"
    }
  }, [_vm._v(" owners share and share alike, according to their percentage of ownership interest, in any and all mineral in place. Individual leases must be executed with each individual or institution that has a mineral interest in the property. Leases")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-418"
    }
  }, [_vm._v(" may involve more than one lessee. In situations where two or more parties own the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-419"
    }
  }, [_vm._v(" in a property, the joint working interest owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-420"
    }
  }, [_vm._v("s have an undivided")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-421"
    }
  }, [_vm._v(" working interest. Joint working interest owners share exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-422"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-423"
    }
  }, [_vm._v(", and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-424"
    }
  }, [_vm._v(" costs and revenues, according to their working interest percentage. Joint working interest owners typically execute a second contract referred to as a joint operating agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-425"
    }
  }, [_vm._v(". Working interests and royalty interests are discussed in detail in ")]), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001"
    }
  }, [_vm._v("chapter 1")]), _vm._v(", and joint operating agreements are discussed in detail in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#chap-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 13")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There are several important provisions included in lease agreements. A few of those most significant to accounting are discussed below:")]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-022"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Lease Bonus or Signature Bonus")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A lease bonus"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-426"
    }
  }, [_vm._v(" or signature bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-427"
    }
  }, [_vm._v(" is the amount paid to the mineral rights owner in return for signing the lease agreement. Lease bonus payments normally are a dollar amount per acre and are paid upon signing. Lease bonus amounts vary widely since they result from negotiations between the mineral rights owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-428"
    }
  }, [_vm._v(" and the oil company representative.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-023"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-428"
    }
  }, [_vm._v("Royalty Provision")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-429"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-429"
    }
  }, [_vm._v("The royalty provision")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-430"
    }
  }, [_vm._v(" is the specified percentage of the oil and gas produced from a property to which the royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-431"
    }
  }, [_vm._v(" owner is entitled. Royalty payments are based on the value of oil and gas produced and may be payable in money or in kind")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-432"
    }
  }, [_vm._v(". Royalty rates may be stated in terms of a fixed rate that does not vary or escalate with production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-433"
    }
  }, [_vm._v(" levels, e.g., 1/8 of"), _c('i', [_vm._v(" all")]), _vm._v(" production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-434"
    }
  }, [_vm._v(" from a property. In contrast, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("some leases call for step-scale or sliding-scale royalties")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-435"
    }
  }, [_vm._v(" requiring more complex formulas. A step-scale royalty rate increases as the"), _c('i', [_vm._v(" average")]), _vm._v(" production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-436"
    }
  }, [_vm._v(" on a lease increases. Sliding-scale royalty rates are based on average production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-437"
    }
  }, [_vm._v(" and apply to all production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-438"
    }
  }, [_vm._v(" from the lease.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-438"
    }
  }, [_vm._v("The example below illustrates a step-scale royalty for oil production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-439"
    }
  }, [_vm._v(" for a month based on average daily production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-440"
    }
  }, [_vm._v(". In this illustration, the royalty goes up by 1% for each incremental tranche of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-441"
    }
  }, [_vm._v(". Based on this formula, if the average daily production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-442"
    }
  }, [_vm._v(" is 650 bbl and the sales price is $40 per bbl the royalty paid in dollars would be:")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-442"
    }
  }, [_vm._v("(400 x $40 x 10%) + (100 bbl x $40 x 11%) + (100 bbl x $40 x 12%) + (50 bbl x $40 x 13%)= "), _c('span', {
    staticClass: "sl"
  }, [_vm._v("$2,780")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-001"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-442"
    }
  }, [_vm._v("EXAMPLE")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-443"
    }
  })]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-443"
    }
  }, [_vm._v("Step-Scale Royalty")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-443"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab30a.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-443"
    }
  }, [_vm._v("Sliding-scale royalty rates are based on average production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-444"
    }
  }, [_vm._v(" and apply to all production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-445"
    }
  }, [_vm._v(" from the lease. The example below illustrates a sliding-scale royalty for oil production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-446"
    }
  }, [_vm._v(" for a month based on average daily production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-447"
    }
  }, [_vm._v(", and the royalty rate for all production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-448"
    }
  }, [_vm._v(" is determined by identifying the rate applicable for the average production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-449"
    }
  }, [_vm._v(" for the month. In this illustration, if the average production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-450"
    }
  }, [_vm._v(" for the lease is 650 bbl, the royalty rate is 13%. Assuming all of the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-451"
    }
  }, [_vm._v(" is sold for $40 per bbl, the royalty paid in dollars would be:")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-451"
    }
  }, [_vm._v("650 bbl x $40 x 13% = $3,300")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-002"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-451"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-451"
    }
  }, [_vm._v("Sliding-scale Royalty")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-452"
    }
  })]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-002"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-452"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab30b.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-452"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("The"), _c('b', [_vm._v(" primary term")])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-453"
    }
  }, [_vm._v(" is the maximum period of time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-454"
    }
  }, [_vm._v(" that the lessee (working interest owner) has to achieve production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-455"
    }
  }, [_vm._v(" from a property. The working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-456"
    }
  }, [_vm._v(" owner may also agree to commence drilling a well within one year from the date the lease was signed. This"), _c('b', [_vm._v(" drilling obligation")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-457"
    }
  }, [_vm._v(" may be deferred by paying a nominal payment called a"), _c('b', [_vm._v(" delay rental payment")]), _vm._v(". Delay rentals are required during the primary term")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-458"
    }
  }, [_vm._v(" of a lease if no drilling or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-459"
    }
  }, [_vm._v(" operations have been undertaken by the working interest owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-460"
    }
  }, [_vm._v("(s). Delay rental")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-461"
    }
  }, [_vm._v(" payments are typically necessary in order for the lessee to retain their interest in the lease while delaying drilling operations for one additional year. After the primary term, a delay rental payment can no longer keep the lease from terminating. Once production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-462"
    }
  }, [_vm._v(" commences the royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-463"
    }
  }, [_vm._v(" owners are compensated through royalty payments they receive and the lease is said to be"), _c('b', [_vm._v(" held by production")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-464"
    }
  }, [_vm._v(". Production from the lease keeps the lease in effect whether during or after the primary term.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-024"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-464"
    }
  }, [_vm._v("Shut-in Payments")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-465"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-465"
    }
  }, [_vm._v("If a well is capable of producing oil or gas in paying quantities but, for some reason, is not producing (typically for an extended period of time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-466"
    }
  }, [_vm._v("), the lessee may be required to make payments to the royalty owner in order to keep the lease in effect. Shut-in payments provide an alternative form of compensation for the royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-467"
    }
  }, [_vm._v(" owner(s) in situations where a well is capable of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-468"
    }
  }, [_vm._v(" but where production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-469"
    }
  }, [_vm._v(" is delayed or halted. For example, shut-in payments")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-470"
    }
  }, [_vm._v(" are common in situations where a well is producing natural gas but access to a pipeline is not available or an oversupply of gas exists. It is unlikely that shut-in payments can be recouped from future royalty payments.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-025"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-470"
    }
  }, [_vm._v("Minimum Royalty Payments")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-471"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-471"
    }
  }, [_vm._v("A minimum royalty clause provides for the payment of a stipulated amount to the lessor regardless of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-472"
    }
  }, [_vm._v(". A minimum royalty is similar to a shut-in")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-473"
    }
  }, [_vm._v(" royalty except that minimum royalty payments may be required in situations where production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-474"
    }
  }, [_vm._v(" is actually occurring but where, due to low levels of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-475"
    }
  }, [_vm._v(" or low selling prices, actual royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-476"
    }
  }, [_vm._v(" fall below a minimum amount. Unlike shut-in payments")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-477"
    }
  }, [_vm._v(", agreements often permit the lessee to recoup minimum royalties from royalty payments, if in the future, sales prices or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-478"
    }
  }, [_vm._v(" levels increase.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-026"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-478"
    }
  }, [_vm._v("Right to Assign Interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-479"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-479"
    }
  }, [_vm._v("Each mineral interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-480"
    }
  }, [_vm._v(" owner of a property has the right to assign all or part of its interest without the approval of any of the other mineral interest owners. For example, the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-481"
    }
  }, [_vm._v(" owner may and often does sell its interest to another company without the permission of the royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-482"
    }
  }, [_vm._v(" owner.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-027"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-482"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  })]), _c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-482"
    }
  }, [_vm._v("Rights to Free Use of Resources")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-483"
    }
  }, [_vm._v(" for Lease Operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-484"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-484"
    }
  }, [_vm._v("Oil or gas produced on a lease may be used to carry out operations on that lease. Royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-485"
    }
  }, [_vm._v(" are not typically paid on production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-486"
    }
  }, [_vm._v(" that is used on the lease from which it was produced. If the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-487"
    }
  }, [_vm._v(" is moved off of the lease and used on another property, royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-488"
    }
  }, [_vm._v(" must be paid.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-488"
    }
  }, [_vm._v("Concession Agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-489"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-489"
    }
  }, [_vm._v("In tax/royalty systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-490"
    }
  }, [_vm._v(" the most frequent types of payments made to the host government are signature bonuses, royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-491"
    }
  }, [_vm._v(", and taxes. The royalty may be a fixed royalty or sliding scale and normally is a percentage of the proceeds from the sale of oil and gas during the period. The royalty is typically paid in cash, but, in some contracts, payment in kind")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-492"
    }
  }, [_vm._v(" is required. The taxes include income taxes and other levies such as duties, production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-493"
    }
  }, [_vm._v(" taxes, value added taxes (VAT), and other special petroleum taxes. For this reason, countries with concessionary fiscal systems are often referred to as being tax/royalty countries")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-494"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-494"
    }
  }, [_vm._v("The following example illustrates a simple concession agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-495"
    }
  }, [_vm._v(":")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-495"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h3', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-495"
    }
  }, [_vm._v("Concession Agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-496"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-496"
    }
  }, [_vm._v("Huge Oil Company signed a concession agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-497"
    }
  }, [_vm._v(" with the government of New Guinea. Huge Oil Company must pay the government, in U.S. dollars, a $20,000,000 signing bonus, a royalty of 12% of the gross value of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-498"
    }
  }, [_vm._v(", and a 6% production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-499"
    }
  }, [_vm._v(" tax based on gross revenue")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-500"
    }
  }, [_vm._v(" from the property. Huge Oil Company must also pay all exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-501"
    }
  }, [_vm._v(", appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-502"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-503"
    }
  }, [_vm._v(", and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-504"
    }
  }, [_vm._v(" costs.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-504"
    }
  }, [_vm._v("Huge Oil Company begins exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-505"
    }
  }, [_vm._v(" andvdrilling late in 2022, spending $200,000,000. Oil is discovered and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-506"
    }
  }, [_vm._v(" begun in 2024. Gross revenue was $80,000,000 and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-507"
    }
  }, [_vm._v(" costs were $15,000,000 for that year. Income taxes are based on net earnings. Production costs and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-508"
    }
  }, [_vm._v(" taxes are deductible when incurred in computing net earnings. Exploration and drilling")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-509"
    }
  }, [_vm._v(" costs are deductible over a 5-year period. The tax income rate is 20%.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-509"
    }
  }, [_vm._v("Gross revenue for 2024 would be shared by the parties as follows:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-003"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-509"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab32.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-509"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("A typical concession agreement")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-510"
    }
  }, [_vm._v(" is similar in principle to a lease agreement wherein the E&P")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-511"
    }
  }, [_vm._v(" company assumes the full risk and cost of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-512"
    }
  }, [_vm._v(", drilling, development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-513"
    }
  }, [_vm._v(", and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-514"
    }
  }, [_vm._v(" activities. If oil or gas is not discovered, the contractor is not typically entitled to recoup any of its costs from the government. If oil or gas is discovered and produced, ownership in the oil or gas is typically transferred to the contractor. The contractor pays royalty payments to the government as the oil and gas are produced and sold. The contract may specify a particular timetable that must be followed by the contractor in undertaking exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-515"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-516"
    }
  }, [_vm._v(" of the contract area.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-028"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-516"
    }
  }, [_vm._v("Concession Agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-517"
    }
  }, [_vm._v(" with Government Participation")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-517"
    }
  }, [_vm._v("Typically, in a concession agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-518"
    }
  }, [_vm._v(" the government’s role is that of a royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-519"
    }
  }, [_vm._v(" owner. In some situations, however, the government may contractually retain the option to participate as a working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-520"
    }
  }, [_vm._v(" owner. The government does not directly participate, but rather a state-owned oil company operates as an agent of the government in its role as a working interest owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-521"
    }
  }, [_vm._v(" in the property. As with other concession agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-522"
    }
  }, [_vm._v(", title to or ownership of a proportionate share of the oil and gas reserves typically passes to the contractor.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-522"
    }
  }, [_vm._v("With this type of agreement, the foreign contractor typically has 100% of the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-523"
    }
  }, [_vm._v(" and thus bears all of the costs and risks involved in the initial exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-524"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-525"
    }
  }, [_vm._v(" of the property (including drilling wells). If commercial reserves")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-526"
    }
  }, [_vm._v(" are found and the decision is made to develop the property, the state-owned oil company may exercise an election to participate as a working interest owner, possibly with an interest of up to 51%. If the state-owned oil company becomes a working interest owner, as with all working interest owners, it typically must pay its proportionate share of all future development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-527"
    }
  }, [_vm._v(" and production"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-528"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-528"
    }
  }, [_vm._v(" costs. A"), _c('b', [_vm._v(" joint venture agreement")]), _vm._v(" or"), _c('b', [_vm._v(" joint operating agreement")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-529"
    }
  }, [_vm._v(" between the contractor and the state-owned oil company typically spells out how costs are to be shared between the parties and how the operations will be financed and managed. In some instances, execution of a joint venture agreement also involves creation of a separate operating company that represents the interests of both the state-owned oil company and the contractor.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-529"
    }
  }, [_vm._v("In cases where the contractor assumes all of the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-530"
    }
  }, [_vm._v(" risk, the concession agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-531"
    }
  }, [_vm._v(" may call for the contractor to recover all or a portion of its exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-532"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-533"
    }
  }, [_vm._v(" expenditures through either direct payment by the government or, more "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("frequently, by the contractor keeping a portion of the state-owned oil company’s share of production")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-534"
    }
  }, [_vm._v(" until the agreed-upon exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-535"
    }
  }, [_vm._v(" costs have been recouped.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-535"
    }
  }, [_vm._v("Regardless of the specific terms of the concession agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-536"
    }
  }, [_vm._v(", the government is typically the royalty owner. In addition, the government may collect income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-537"
    }
  }, [_vm._v("es and other taxes, e.g., special petroleum taxes and VAT. Customs duties may be imposed on imported materials and supplies, but production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-538"
    }
  }, [_vm._v(" is generally exempted from export duties.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-538"
    }
  }, [_vm._v("Production/Profit Sharing Systems")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-538"
    }
  }, [_vm._v("In many countries, the government retains title to and ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-539"
    }
  }, [_vm._v(" of all mineral reserves; as such, ownership of any minerals"), _c('i', [_vm._v(" in the ground")]), _vm._v(", i.e., the oil and gas reserves and resources, never passes to a foreign company. Instead the ownership typically does not pass to the contractor at or near the point of sale. Most often the contractor receives an in-kind")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-540"
    }
  }, [_vm._v(" share of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-541"
    }
  }, [_vm._v(", but in some cases the contractor may receive cash upon the sale of the oil or gas. As indicated earlier, countries where the government owns and retains the mineral rights are referred to as having"), _c('b', [_vm._v(" production")])]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-542"
    }
  }, [_vm._v("/profit sharing systems")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-543"
    }
  }, [_vm._v(". In production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-544"
    }
  }, [_vm._v("/profit sharing systems title to and ownership of equipment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-545"
    }
  }, [_vm._v(" and facilities utilized in exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-546"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-547"
    }
  }, [_vm._v(", and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-548"
    }
  }, [_vm._v(" pass immediately to the government or to the state-owned oil company. PSCs and service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-549"
    }
  }, [_vm._v(" are the most common types of contracts used in production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-550"
    }
  }, [_vm._v("/profit sharing systems, with PSCs being most common.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-550"
    }
  }, [_vm._v("Production Sharing Contracts")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-551"
    }
  }, [_vm._v(" (Agreements) and Terms")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-551"
    }
  }, [_vm._v("Almost every contract has its own unique terms and characteristics. While it is quite informative to read and examine sample PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-552"
    }
  }, [_vm._v("s, most PSCs are proprietary making it difficult to obtain permission to reprint them in this book. Furthermore, the provisions found in PSCs are so varied that one single sample contract could not contain all of the clauses and provisions actually found in practice. As an alternative, some of the provisions that are frequently found in PSCs are described below, including an example of many of the key provisions. There are numerous provisions that may be included in contracts that are not discussed or illustrated in this book. This by no means indicates that the provisions are not significant to the accountant.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-029"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-552"
    }
  }, [_vm._v("Bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-553"
    }
  }, [_vm._v(" Payments")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-553"
    }
  }, [_vm._v("In PSCs the contractor is typically required to pay the government a bonus, i.e., a signature bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-554"
    }
  }, [_vm._v(", upon the execution of the agreement. Signature bonuses may range in amount from zero to hundreds of millions of dollars. While certain "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("exploration")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-555"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-556"
    }
  }, [_vm._v(", and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-557"
    }
  }, [_vm._v(" costs may be recouped or recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-558"
    }
  }, [_vm._v(" from future production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-559"
    }
  }, [_vm._v(", signature bonuses are rarely, if ever, recoverable.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-559"
    }
  }, [_vm._v("In some contracts, a relatively smaller bonus (or, in some cases, no bonus) is paid when the contract is signed with another payment being made when discoveries are made and/or as production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-560"
    }
  }, [_vm._v(" occurs. One such bonus is referred to as a"), _c('b', [_vm._v(" development")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-561"
    }
  }, [_c('b', [_vm._v(" bonus")]), _vm._v(" which is due if exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-562"
    }
  }, [_vm._v(" activities result in discovery of oil and gas culminating in the decision to develop a specific field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-563"
    }
  }, [_vm._v(" within the contract area. Development bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-564"
    }
  }, [_vm._v("es are typically paid when the contractor and the state-owned oil company approve a development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-565"
    }
  }, [_vm._v(" plan for the field.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-565"
    }
  }, [_vm._v("Bonuses may also be tied to production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-566"
    }
  }, [_vm._v(". In some cases, no or relatively smaller bonuses are paid at the signing of the contract with subsequent bonus payments being made to the government if and when production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-567"
    }
  }, [_vm._v(" reaches specified levels. These payments are referred to as"), _c('b', [_vm._v(" production")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-568"
    }
  }, [_c('b', [_vm._v(" bonuses")]), _vm._v(". Some contracts require payment of signature bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-569"
    }
  }, [_vm._v("es as well as development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-570"
    }
  }, [_vm._v(" and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-571"
    }
  }, [_vm._v(" bonuses. Other contracts may require no bonus payments at all. However, some combination of signature, development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-572"
    }
  }, [_vm._v(", and/or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-573"
    }
  }, [_vm._v(" bonuses is typically required.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-573"
    }
  }, [_vm._v("If a government agrees to defer receipt of bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-574"
    }
  }, [_vm._v(" payments until development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-575"
    }
  }, [_vm._v(" or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-576"
    }
  }, [_vm._v(", it is assuming the risk that development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-577"
    }
  }, [_vm._v(" or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-578"
    }
  }, [_vm._v(" might never occur. That is, if oil or gas is not discovered or if production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-579"
    }
  }, [_vm._v(" does not reach the specified level, the government will not receive the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-580"
    }
  }, [_vm._v(" or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-581"
    }
  }, [_vm._v(" bonus payments. However, such risk is offset with the hope that a lower up-front signature bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-582"
    }
  }, [_vm._v(" will allow the contractor to invest more money and to invest money more quickly in exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-583"
    }
  }, [_vm._v(" activities, potentially resulting in more timely discoveries of oil and gas.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-583"
    }
  }, [_vm._v("The following example provides an illustration of the language that might appear in a PSC"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-584"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-584"
    }
  }, [_vm._v(" that provides for the payment of a production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-585"
    }
  }, [_vm._v(" bonus.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-004"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-585"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-585"
    }
  }, [_vm._v("Contract Language Defining Production Bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-586"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-586"
    }
  }, [_vm._v("Production bonuses are payable on first attainment of a sixty (60) consecutive day average at or in excess of the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-587"
    }
  }, [_vm._v(" levels in detailed below:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-004"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-587"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab35.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-587"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("In computing the production")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-588"
    }
  }, [_vm._v(" levels referred to above, natural gas production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-589"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-590"
    }
  }, [_vm._v(" shall be added to crude oil production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-591"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-592"
    }
  }, [_vm._v(" after converting to barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-593"
    }
  }, [_vm._v(" of oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-594"
    }
  }, [_vm._v(" on an energy equivalent basis. When production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-595"
    }
  }, [_vm._v(" reaches 25,000 bopd, a bonus of $500,000 is paid; when production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-596"
    }
  }, [_vm._v(" reaches 50,000, an additional $750,000 is paid, and so forth.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-030"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-596"
    }
  }, [_vm._v("Royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-597"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-597"
    }
  }, [_vm._v("Despite the fact that title to or ownership of the mineral")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-598"
    }
  }, [_vm._v("s in the ground never passes to the contractor, more recent PSCs often contain royalty provisions whereby a royalty is paid to the government. The royalty provision")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-599"
    }
  }, [_vm._v("s in PSCs typically range from zero to 14 or 15%. Royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-600"
    }
  }, [_vm._v(" may be paid either in kind or in money. Payment in kind")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-601"
    }
  }, [_vm._v(" involves delivery of physical quantities of oil or gas to the state-owned oil company or government-owned refining/distribution facilities. When the state-owned oil company sells or disposes of the oil or gas, the proceeds are typically remitted to the appropriate ministry or governmental agency.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-601"
    }
  }, [_vm._v("Royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-602"
    }
  }, [_vm._v(" are normally based on gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-603"
    }
  }, [_vm._v(", with no consideration of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-604"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-605"
    }
  }, [_vm._v(", or operating costs or cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-606"
    }
  }, [_vm._v(". As a consequence, it is sometimes claimed that the payment of royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-607"
    }
  }, [_vm._v(" may serve as a disincentive for new drilling and development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-608"
    }
  }, [_vm._v(" expenditures. In order to partially offset this effect, contracts may be written so that royalties are paid on a sliding-scale basis. As indicated earlier, sliding-scale royalties are designed so that the royalty rate is lower when production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-609"
    }
  }, [_vm._v(" is lower and increases as average daily production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-610"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-611"
    }
  }, [_vm._v(" levels increase. In marginal situations with low production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-612"
    }
  }, [_vm._v(", a lower royalty rate may result in production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-613"
    }
  }, [_vm._v(" that would otherwise not have been profitable.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-031"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-613"
    }
  }, [_vm._v("Joint Management Committees")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-613"
    }
  }, [_vm._v("A common feature of most PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-614"
    }
  }, [_vm._v("s is the formation of a joint management committee")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-615"
    }
  }, [_vm._v(". Joint management committees are normally composed of representatives from the contractor as well as representatives from the state-owned oil company. The role of the joint management committee is to permit all of the stakeholders to be directly involved in the key decisions regarding the property, including development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-616"
    }
  }, [_vm._v(" and operations of any field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-617"
    }
  }, [_vm._v(" discovered in the contract area. In concession agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-618"
    }
  }, [_vm._v(" and lease contracts, the operator may be in charge of making most of the day-to-day operating decisions. In production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-619"
    }
  }, [_vm._v("/profit sharing systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-620"
    }
  }, [_vm._v(" the joint management committee must approve all of the key decisions related to operations of the property")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-621"
    }
  }, [_vm._v(". The operator of the property usually prepares an annual work program and budget for review and approval by the joint management committee. The joint management committee typically makes all major operational decisions, including approval of all major expenditures, evaluation of the results of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-622"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-623"
    }
  }, [_vm._v(", and determination of the commerciality of newly discovered reservoirs.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-032"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-623"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Government Participation in Operations")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-623"
    }
  }, [_vm._v("In most PSCs the government through the state-owned oil company does not have a working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-624"
    }
  }, [_vm._v(" during exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-625"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-626"
    }
  }, [_vm._v(" operations. In such situations all of the costs of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-627"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-628"
    }
  }, [_vm._v(" costs are borne by the contractor. The contractor bears all of the risks and costs. If no oil and gas is found, the contractor cannot seek reimbursement of any of the costs incurred. The contractor recoups its exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-629"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-630"
    }
  }, [_vm._v(" expenditures only if production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-631"
    }
  }, [_vm._v(" occurs. If commercial reserves")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-632"
    }
  }, [_vm._v(" are discovered, the state-owned oil company may elect to participate as a working interest owner")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-633"
    }
  }, [_vm._v(" up to an agreed upon maximum, possibly as high as 51%. If the state-owned oil company elects to participate, as with any other working interest owner, the state-owned oil company would pay its proportionate share of the subsequent development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-634"
    }
  }, [_vm._v(" and operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-635"
    }
  }, [_vm._v(".")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-033"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-635"
    }
  }, [_vm._v("Training and Technology Transfer")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-636"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-636"
    }
  }, [_vm._v("Another common feature of contracts in production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-637"
    }
  }, [_vm._v("/profit sharing systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-638"
    }
  }, [_vm._v(" is the transfer of knowledge and technology to the local staff. The contractor must use the most advanced technology and may be required to transfer the knowledge regarding the technology to their local staff and, possibly, employees of the state-oil company who are assigned to the particular operations. The contractor may be allowed to bring some of its own expatriate employees into the host country; however, typically the majority of employees must be permanent citizens of the country where the operations are occurring. These employees must be trained by the contractor, with the training normally continuing throughout the entire operations of the property or throughout the life of the contract if shorter. In many PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-639"
    }
  }, [_vm._v("s, the cost of training, which is a significant cost, is a recoverable cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-640"
    }
  }, [_vm._v(".")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-034"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-640"
    }
  }, [_vm._v("Phases of operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-641"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-641"
    }
  }, [_vm._v("The phase of operations in which a cost is incurred is significant because, as discussed earlier, the contractor commonly provides all of the funding during the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-642"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-643"
    }
  }, [_vm._v(" phase of the contract whereas the costs incurred during the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-644"
    }
  }, [_vm._v(" and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-645"
    }
  }, [_vm._v(" phases are often shared between the contractor and the state-owned oil company. Additionally, the timing")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-646"
    }
  }, [_vm._v(" of expenditures often determines the order in which costs are recovered. The phase of operation")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-647"
    }
  }, [_vm._v(" is also important for a number of other reasons. For example, the contract usually specifies minimum expenditures that the contractor must make during the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-648"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-649"
    }
  }, [_vm._v(" phase. Also, unlike U.S. leases that continue in effect so long as production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-650"
    }
  }, [_vm._v(" occurs, PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-651"
    }
  }, [_vm._v("s typically state a maximum length of time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-652"
    }
  }, [_vm._v(" for the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-653"
    }
  }, [_vm._v(" phase of each field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-654"
    }
  }, [_vm._v(" as well as a maximum life for the contract. This does not mean, however, that all of the oil and gas reserves and resources must be produced during the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-655"
    }
  }, [_vm._v(" phase; rather, the clause limits that length of time"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-656"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-656"
    }
  }, [_vm._v(" that the contractor may be involved in production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-657"
    }
  }, [_vm._v(" operations from the particular field.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-005"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-657"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("EXAMPLE")])])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-657"
    }
  }, [_vm._v("Contract Language Defining Phases of Operations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-658"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-658"
    }
  }, [_vm._v("The term of the contract shall include an exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-659"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-660"
    }
  }, [_vm._v(" period, a development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-661"
    }
  }, [_vm._v(" period, and a production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-662"
    }
  }, [_vm._v(" period. The exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-663"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-664"
    }
  }, [_vm._v(" period for the entire contract area commences on the date that the contract is signed. The development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-665"
    }
  }, [_vm._v(" period for any individual field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-666"
    }
  }, [_vm._v(" shall begin on the date of declaration of commerciality and end when commercial production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-667"
    }
  }, [_vm._v(" commences. The production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-668"
    }
  }, [_vm._v(" period of any field within the contract area shall continue for a period no longer than fifteen (15) consecutive years. However, in no event shall the overall term of the contract extend beyond thirty (30) consecutive years from the date the contract is signed.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-668"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-668"
    }
  }, [_vm._v("If the end of the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-669"
    }
  }, [_vm._v(" period occurs prior to the end of actual production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-670"
    }
  }, [_vm._v(" from a field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-671"
    }
  }, [_vm._v(", the state-owned oil company typically takes over the operation as the operator and becomes the owner of 100% of the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-672"
    }
  }, [_vm._v(". Of course, it is always possible that the government could opt to renegotiate with the contractor allowing the contractor’s involvement to continue; however, this would typically not occur unless doing so is beneficial to all parties.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-035"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-672"
    }
  }, [_vm._v("Minimum Work Commitment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-673"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-673"
    }
  }, [_vm._v("The contract may not only specify the overall length of the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-674"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-675"
    }
  }, [_vm._v(" phase, it may also divide the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-676"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-677"
    }
  }, [_vm._v(" period into various stages. Each stage must typically be completed within a specified period of time"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-678"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-678"
    }
  }, [_vm._v(" with the contractor agreeing to conduct specific operations, i.e., conduct a defined amount of seismic"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-679"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-679"
    }
  }, [_vm._v(" and drill a predefined number of wells, and/or spend a specified amount of money.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-006"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-679"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-679"
    }
  }, [_vm._v("Contract Language Defining Minimum Work Commitment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-680"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-681"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-681"
    }
  }, [_vm._v("The exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-682"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-683"
    }
  }, [_vm._v(" period, beginning on the date of the signing of this agreement, shall be divided into three (3) stages and shall consist of eight (8) consecutive contract years, unless it terminates earlier.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-683"
    }
  }, [_vm._v("The three (3) stages shall be as follows:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-683"
    }
  }, [_vm._v("Stage one consisting of four (4) contract years")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-683"
    }
  }, [_vm._v("Stage two consisting of two (2) contract years")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-683"
    }
  }, [_vm._v("Stage three consisting of two (2) contract years")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-683"
    }
  }, [_vm._v("During the first stage of the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-684"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-685"
    }
  }, [_vm._v(" period, the Contractor shall:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-685"
    }
  }, [_vm._v("Complete seismic lines totaling 10,000 kilometers")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-685"
    }
  }, [_vm._v("Drill and complete two (2) wildcat well(s) and")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-685"
    }
  }, [_vm._v("Spend $150,000,000 U.S. dollars.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-685"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("During the second stage of the exploration")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-686"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-687"
    }
  }, [_vm._v(" period, the Contractor shall:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-687"
    }
  }, [_vm._v("Complete seismic lines totaling 12,000 kilometers")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-687"
    }
  }, [_vm._v("Drill and complete three (3) wildcat well(s) and/or appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-688"
    }
  }, [_vm._v(" well(s)")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-688"
    }
  }, [_vm._v("Spend $260,000,000 U.S. dollars.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-688"
    }
  }, [_vm._v("During the third stage of the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-689"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-690"
    }
  }, [_vm._v(" period, the Contractor shall:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-690"
    }
  }, [_vm._v("Complete seismic lines totaling 8,000 kilometers")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-690"
    }
  }, [_vm._v("Drill and complete three (3) wildcat well(s) and/or appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-691"
    }
  }, [_vm._v(" well(s)")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-691"
    }
  }, [_vm._v("Spend $360,000,000 U.S. dollars.")])])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-036"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-691"
    }
  }, [_vm._v("Relinquishment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-692"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-692"
    }
  }, [_vm._v("The contract typically requires the management committee to evaluate the results of exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-693"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-694"
    }
  }, [_vm._v(" at the end of each defined stage during the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-695"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-696"
    }
  }, [_vm._v(" phase. Since each PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-697"
    }
  }, [_vm._v(" typically covers a very large area, from the government’s perspective, it is important for the contractor to explore as much acreage as possible as quickly as possible. Therefore, most PSCs include a relinquishment provision wherein the contractor must decide whether to continue exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-698"
    }
  }, [_vm._v(" or terminate the contract at the end of each stage within the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-699"
    }
  }, [_vm._v(" period. If the contractor elects to go forward and continue exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-700"
    }
  }, [_vm._v(", the contract typically specifies some amount of acreage from the original contract area that the contractor is required to relinquish. This provision facilitates any efforts on the part of the government to contract with another company for the continued exploration"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-701"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-701"
    }
  }, [_vm._v(" of the relinquished acreage. If, at the end of any phase, the contractor elects not to continue, all of the remaining acreage is relinquished.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-007"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-701"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-701"
    }
  }, [_vm._v("Contract Language Relinquishment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-702"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-703"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-703"
    }
  }, [_vm._v("At the expiration of the first stage or the second stage of the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-704"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-705"
    }
  }, [_vm._v(" period, the contractor has the option to either enter the next stage and continue exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-706"
    }
  }, [_vm._v(" or terminate the contract. If, at the end of the first stage, the decision is made to enter the second stage, then an amount of acreage equal to 50% of the original contract area must be relinquished. If, at the end of the second stage, the decision is made to enter the third stage, then an amount of acreage equal to 50% of the acreage retained at the beginning of the second stage must be relinquished after subtracting any acreage included in development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-707"
    }
  }, [_vm._v(" or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-708"
    }
  }, [_vm._v(" operations. Any remaining acreage not included in development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-709"
    }
  }, [_vm._v(" or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-710"
    }
  }, [_vm._v(" operations must be relinquished at the end of the third stage.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-710"
    }
  }, [_vm._v("Any monetary amount that has been expended in excess of the minimum work commitment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-711"
    }
  }, [_vm._v(" shall be carried over and treated as being related to the subsequent "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("stage. However, if the decision is made not to go into the subsequent stage, or at the end of the exploration")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-712"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-713"
    }
  }, [_vm._v(" period, if the amount that has been expended is less than the minimum work commitment, any deficiency shall be paid over to the government in cash and shall not be recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-714"
    }
  }, [_vm._v(" from any production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-715"
    }
  }, [_vm._v(" that might ultimately be achieved from the contract area.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-037"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-715"
    }
  }, [_vm._v("Cost Recovery")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-715"
    }
  }, [_vm._v("Cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-716"
    }
  }, [_vm._v(" is the procedure by which the contractor and the state-owned oil company are able to recover their costs by being able to sell a portion of the oil and gas produced. All PSCs contain cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-717"
    }
  }, [_vm._v(" provisions. Recall that in production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-718"
    }
  }, [_vm._v("/profit sharing systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-719"
    }
  }, [_vm._v(" ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-720"
    }
  }, [_vm._v(" of or title to oil and gas does not pass to the contractor until after it is produced, typically not until it reaches the point of sale. Therefore, the contractually defined quantity of oil and gas that enables the contractor to recoup its costs is referred to as the contractor’s entitlement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-721"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-721"
    }
  }, [_vm._v("The contract will specify which costs are recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-722"
    }
  }, [_vm._v(", the order of recoverability, any limits on recoverability, and whether costs not recovered in one period may be carried forward into future periods. Most contracts specify that recoverable costs not recovered in any given year may be carried forward to future years.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-722"
    }
  }, [_vm._v("The oil or gas that is produced during any given period (e.g"), _c('i', [_vm._v(".,")]), _vm._v(" a month or a year) is divided between the government, the state-owned oil company, and the contractor. The portion or production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-723"
    }
  }, [_vm._v(" that goes to the state-owned oil company and the contractor (the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-724"
    }
  }, [_vm._v(" owners) for the purpose of allowing them to recover their costs is referred to as"), _c('b', [_vm._v(" cost oil")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-725"
    }
  }, [_c('b', [_vm._v(" (or gas)")]), _vm._v(" or"), _c('b', [_vm._v(" cost recovery")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-726"
    }
  }, [_c('b', [_vm._v(" oil (or gas)")]), _vm._v(". Each contract typically established a maximum amount of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-727"
    }
  }, [_vm._v(" that can be used for cost recovery in any given period. This is referred to as the"), _c('b', [_vm._v(" cost oil (or gas) cap")]), _vm._v(". The cost oil or gas cap vary from one contract to another.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-727"
    }
  }, [_vm._v("Obviously, the contractor would prefer for the cost oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-728"
    }
  }, [_vm._v(" cap to be as high as possible thus permitting them to recover their costs more rapidly while the government may prefer a lower cost oil cap. A cost oil cap might be, for example, 50% of the gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-729"
    }
  }, [_vm._v(" during any given year. That means, regardless of actual production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-730"
    }
  }, [_vm._v(" or the actual costs incurred, only 50% of the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-731"
    }
  }, [_vm._v(" can be allocated for cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-732"
    }
  }, [_vm._v(". Most PSCs permit unrecovered costs from one period to be carried forward to subsequent periods. Hopefully, if cumulative production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-733"
    }
  }, [_vm._v(" is sufficient, the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-734"
    }
  }, [_vm._v(" owners will eventually recover 100% of their recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-735"
    }
  }, [_vm._v(" expenditures.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-735"
    }
  }, [_vm._v("Most contracts specify the order in which costs are to be recovered. Although the order of recovery of costs varies across PSCs, a common order of cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-736"
    }
  }, [_vm._v(" is:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-736"
    }
  }, [_vm._v("Current period operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-737"
    }
  })])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-737"
    }
  }, [_vm._v("Unrecovered operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-738"
    }
  }, [_vm._v(" from a prior period")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-738"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("Unrecovered exploration")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-739"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-740"
    }
  }, [_vm._v(" expenditures (typically paid 100% by the contractor)")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-740"
    }
  }, [_vm._v("Unrecovered development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-741"
    }
  }, [_vm._v(" expenditures")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-741"
    }
  }, [_vm._v("ny investment credit or capital uplift")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-742"
    }
  }, [_vm._v(" (defined later)")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-742"
    }
  }, [_vm._v("In most cases, the costs recovered first are the current period operating costs. If the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-743"
    }
  }, [_vm._v(" together with the cost oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-744"
    }
  }, [_vm._v(" or gas cap")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-745"
    }
  }, [_vm._v(" are sufficient to permit recovery of all current period operating expenditures, then the next in order is likely to be any operating expenditures that were not fully recovered in prior periods.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-745"
    }
  }, [_vm._v("The order of cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-746"
    }
  }, [_vm._v(" is of key importance. Once all operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-747"
    }
  }, [_vm._v(" are recovered, if the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-748"
    }
  }, [_vm._v(">")]), _vm._v(" together with the cost oil"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-749"
    }
  }, [_vm._v(" or gas cap are sufficient, the next cost to be recovered is often exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-750"
    }
  }, [_vm._v(" and evaluation costs; however, some contracts have development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-751"
    }
  }, [_vm._v(" costs next in line for cost recovery. The contractor would logically prefer that exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-752"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-753"
    }
  }, [_vm._v(" costs be next in line for cost recovery since exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-754"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-755"
    }
  }, [_vm._v(" costs are typically incurred in the very earliest stages and therefore may have been expended many years before production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-756"
    }
  }, [_vm._v(" actually commences, and since the contractor likely paid 100% of those costs. Accordingly, in most PSCs the next tier of costs in the cost recovery sequence are exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-757"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-758"
    }
  }, [_vm._v(" expenditures.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-758"
    }
  }, [_vm._v("Development costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-759"
    }
  }, [_vm._v(" are typically paid by both the contractor and the state-owned oil company in proportion with their working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-760"
    }
  }, [_vm._v(" and tend to be the largest cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-761"
    }
  }, [_vm._v(" category. Therefore, it may take a number of years before development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-762"
    }
  }, [_vm._v(" costs are fully recovered. Some contracts do not limit the amount of development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-763"
    }
  }, [_vm._v(" costs permitted to be recovered in any given year; however, some contracts require that development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-764"
    }
  }, [_vm._v(" costs be “depreciated")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-765"
    }
  }, [_vm._v("” over a specified period of time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-766"
    }
  }, [_vm._v(". For example, if a contract indicates that development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-767"
    }
  }, [_vm._v(" costs are to be depreciated")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-768"
    }
  }, [_vm._v(" (for purposes of cost recovery) over a ten (10) year period, then a maximum of 1/10 of the total development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-769"
    }
  }, [_vm._v(" cost incurred would be recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-770"
    }
  }, [_vm._v(" in any given year.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-008"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-770"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-770"
    }
  }, [_vm._v("Contract Language Defining Cost Oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-771"
    }
  }, [_vm._v(" Split and Order of Cost Recovery")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-771"
    }
  }, [_vm._v("For each year the gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-772"
    }
  }, [_vm._v(" from any field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-773"
    }
  }, [_vm._v(" within the contract area shall be divided according to the following sequence:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-773"
    }
  }, [_vm._v("Eight percent (8%) of the annual gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-774"
    }
  }, [_vm._v(" shall be used for payment of royalty")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-775"
    }
  }, [_vm._v(" to the Government of ______;")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-775"
    }
  }, [_vm._v("Five percent (5%) of the annual gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-776"
    }
  }, [_vm._v(" shall be used for payments of the Value Added Tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-777"
    }
  }, [_vm._v(";")])]), _c('p', {
    staticClass: "txt_courant_ssalinea last retrait_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-777"
    }
  }, [_vm._v("Forty-five percent (45%) of the annual gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-778"
    }
  }, [_vm._v(" of crude oil shall be “cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-779"
    }
  }, [_vm._v(" oil” and shall be used for cost recovery in the following sequence:")])])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-779"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("Payment in kind")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-780"
    }
  }, [_vm._v(" for the operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-781"
    }
  }, [_vm._v(" actually incurred but not yet recovered by the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-782"
    }
  }, [_vm._v(" owners")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-782"
    }
  }, [_vm._v("Payment in kind")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-783"
    }
  }, [_vm._v(" for the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-784"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-785"
    }
  }, [_vm._v(" costs actually incurred but not yet recovered by the Contractor")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-785"
    }
  }, [_vm._v("Payment in kind")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-786"
    }
  }, [_vm._v(" for the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-787"
    }
  }, [_vm._v(" costs actually incurred but not yet recovered by the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-788"
    }
  }, [_vm._v(" owners")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-788"
    }
  }, [_vm._v("Any unrecovered operating costs shall be carried forward indefinitely and recovered from cost recovery oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-789"
    }
  }, [_vm._v(" in succeeding years until fully recovered. Any unrecovered exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-790"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-791"
    }
  }, [_vm._v(" or development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-792"
    }
  }, [_vm._v(" costs shall be recovered from available cost recovery oil until fully recovered; however, the maximum period that any unrecovered development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-793"
    }
  }, [_vm._v(" cost can be carried forward is ten (10) years. Any remaining unrecovered costs remaining at the end of the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-794"
    }
  }, [_vm._v(" period shall be deemed to be a loss and no other form of reimbursement shall be provided for or anticipated.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-794"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-794"
    }
  }, [_vm._v("Any oil available for cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-795"
    }
  }, [_vm._v(" oil in a particular year that is in excess of the amount necessary for cost recovery may be referred to as"), _c('b', [_vm._v(" excess cost oil")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-796"
    }
  }, [_c('b', [_vm._v(" (or gas)")]), _vm._v(". In many cases this production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-797"
    }
  }, [_vm._v(" becomes profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-798"
    }
  }, [_vm._v(" or is allocated to the parties in the same manner as the profit oil (see next section). In other cases, the contract may dictate that the majority of the excess cost oil be allocated to the government.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-009"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-798"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-798"
    }
  }, [_vm._v("Contract Language Allocating Excess Cost Oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-799"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-799"
    }
  }, [_vm._v("To the extent that the cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-800"
    }
  }, [_vm._v(" crude oil in any year exceeds the total of all of the petroleum costs to be recovered in such year, then the portion of such cost recovery crude oil in excess of the said recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-801"
    }
  }, [_vm._v(" petroleum costs becomes excess cost recovery oil"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-802"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-802"
    }
  }, [_vm._v(" and shall be shared between the contractor and the state oil company in the ratio of 90% for the state oil company and 10% to the contractor.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-038"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-802"
    }
  }, [_vm._v("Profit Oil")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-802"
    }
  }, [_vm._v("The production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-803"
    }
  }, [_vm._v(" normally first goes to pay royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-804"
    }
  }, [_vm._v(", next to pay production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-805"
    }
  }, [_vm._v("-related taxes such as production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-806"
    }
  }, [_vm._v(" taxes or VAT")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-807"
    }
  }, [_vm._v(", and then to cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-808"
    }
  }, [_vm._v(" and to"), _c('b', [_vm._v(" profit oil")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-809"
    }
  }, [_c('b', [_vm._v(" or gas")]), _vm._v(". In any given period, profit oil (or gas) is split between the government, the state-owned oil company, and the contractor regardless of whether all recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-810"
    }
  }, [_vm._v(" costs have been recovered. Profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-811"
    }
  }, [_vm._v(" (or gas) is a contractually defined term; the term does"), _c('i', [_vm._v(" not")]), _vm._v(" refer to profits or net income determined according to financial accounting policies and practices. If there is any production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-812"
    }
  }, [_vm._v(" whatsoever, some portion of that production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-813"
    }
  }, [_vm._v(" is assigned to the profit oil or gas category.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-010"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-813"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("EXAMPLE")])])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-813"
    }
  }, [_vm._v("Profit Oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-814"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-814"
    }
  }, [_vm._v("Huge Oil Company is a party to a contract that specifies the following:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-814"
    }
  }, [_vm._v("Royalty of 12% of gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-815"
    }
  })])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-815"
    }
  }, [_vm._v("Production tax of 6% of gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-816"
    }
  })])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-816"
    }
  }, [_vm._v("Cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-817"
    }
  }, [_vm._v(" oil equal to a maximum of 50% of gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-818"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-818"
    }
  }, [_vm._v("Profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-819"
    }
  }, [_vm._v(" is equal to:")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-819"
    }
  }, [_vm._v("100% - (12% + 6% + 50%) = "), _c('span', {
    staticClass: "sl"
  }, [_vm._v("32%")])])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-819"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-819"
    }
  }, [_vm._v("Profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-820"
    }
  }, [_vm._v(" and profit gas")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-821"
    }
  }, [_vm._v(" calculations are typically among the most varied and complex formulas in PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-822"
    }
  }, [_vm._v("s. Although in most settings the term “profit” refers to revenues minus expenses or accounting net income, that is not the case with PSCs. In PSCs profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-823"
    }
  }, [_vm._v(" or gas basically refers to a quantity of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-824"
    }
  }, [_vm._v(" that is shared between the parties—normally between the government, the contractor, and the state-owned oil company based on a specific metric or formula. The profit oil or gas provision allows for the government to get an additional slice of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-825"
    }
  }, [_vm._v(" (in addition to royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-826"
    }
  }, [_vm._v(" and certain taxes) while still allowing the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-827"
    }
  }, [_vm._v(" owners to recover some of their costs and get a return on their investment. The term profit oil (or profit gas) is contractually defined and therefore is unrelated to any financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-828"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-829"
    }
  }, [_vm._v(" measure of profitability.")])])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-011"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-829"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-829"
    }
  }, [_vm._v("Contract Language Defining Profit Oil Split")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-830"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-830"
    }
  }, [_vm._v("The remainder of gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-831"
    }
  }, [_vm._v(" after the allocation of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-832"
    }
  }, [_vm._v(" for the purpose of cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-833"
    }
  }, [_vm._v(" after having applied the cost oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-834"
    }
  }, [_vm._v(" ceiling or cap shall be referred to as profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-835"
    }
  }, [_vm._v(". Such profit oil is to be divided between the share for the government and the amount of profit oil to be shared by the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-836"
    }
  }, [_vm._v(" parties. Factor “R” is to be computed for each field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-837"
    }
  }, [_vm._v(" in the contract area. Each calendar year the profit oil for each field shall be multiplied by factor “R.” Factor “R” is to be determined according to the following tiers:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-005"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-837"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab43.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-837"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("Factor “R” times the amount of profit oil")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-838"
    }
  }, [_vm._v(" goes to the parties based on their working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-839"
    }
  }, [_vm._v(" in the field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-840"
    }
  }, [_vm._v("; (1 – R%) goes to the government.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-840"
    }
  }, [_vm._v("Assume, for example, gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-841"
    }
  }, [_vm._v(" for the year is 4,500,000 barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-842"
    }
  }, [_vm._v("; then factor R is equal to:")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fonctionp44"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-842"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/fonctionp44.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-842"
    }
  }, [_vm._v("In this case the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-843"
    }
  }, [_vm._v(" owners would share 77.22% of the profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-844"
    }
  }, [_vm._v(" (split based on their working interest in the property) with (100% - 77.22%) or 22.78% of the profit oil going to the government.")])]), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-844"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-844"
    }
  }, [_vm._v("The sharing of profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-845"
    }
  }, [_vm._v(" varies widely between contracts. Some contracts allocate a specified percentage of the profit oil or gas directly to the government with the contractor and the state-owned oil company sharing the remaining profit oil in proportion to their working interests. That strategy is illustrated in the example below:")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-012"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-845"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-845"
    }
  }, [_vm._v("Contract Language Defining Profit Oil Split")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-846"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-846"
    }
  }, [_vm._v("All profit crude oil originating in each quarter is to be allocated as follows:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-006"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-846"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab44.jpg"
    }
  })])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-039"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-846"
    }
  }, [_vm._v("Recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-847"
    }
  }, [_vm._v(" Costs")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-847"
    }
  }, [_vm._v("The fact that a cost item is incurred during a particular phase of the contract does not necessarily make the costs recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-848"
    }
  }, [_vm._v(". Each PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-849"
    }
  }, [_vm._v(" should have a section or appendix referred to as the accounting procedure. A key feature in most accounting procedures")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-850"
    }
  }, [_vm._v(" is to set out the major categories of costs that are directly associated with a property and that are cost recoverable as well as an explanation of how indirect costs or overhead"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-851"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-851"
    }
  }, [_vm._v(" is to be determined. Below is a list (not necessarily all-inclusive) of the types of direct cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-852"
    }
  }, [_vm._v("s that are typically treated as recoverable.")])]), _c('p', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-852"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-852"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_c('b', [_vm._v("Subcontractor charges")])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-853"
    }
  }, [_vm._v("—Refers to charges paid to subcontractors in accordance with contracts signed between the operator and subcontractors, e.g., services provided by a well servicing firm or electrical repairs provided by an electrical subcontractor.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-853"
    }
  }, [_c('b', [_vm._v("Personnel expenses—")]), _vm._v("Are to include gross salaries and wages paid to employees directly employed in operations.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-853"
    }
  }, [_c('b', [_vm._v("Benefits")]), _vm._v("—Include costs of all holidays, vacation, sickness, disability, and other like benefits; also cost of life insurance, hospitalization, pensions, and other benefits, in accordance with the contractor’s usual practices.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-853"
    }
  }, [_c('b', [_vm._v("Travel and living expenses")]), _vm._v("—Reimbursement limited to employees directly employed in operations.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-853"
    }
  }, [_c('b', [_vm._v("Material and equipment")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-854"
    }
  }, [_vm._v("—Reimbursement limited to material and equipment purchased or furnished by contractor for use in the operations.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-854"
    }
  }, [_c('b', [_vm._v("Employee relocation and transportation")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-855"
    }
  }, [_c('b', [_vm._v(" expenses")]), _vm._v("—Costs incurred for transportation of personnel directly involved in operations and for the relocation of employees (permanently or temporarily) to and from their point of origin in accordance with the contractor’s usual practices.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-855"
    }
  }, [_c('b', [_vm._v("Maintenance")])]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-856"
    }
  }, [_vm._v(", repair, replacement, and leasing expenses")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-856"
    }
  }, [_vm._v("—Related to equipment and facilities used in operations.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-856"
    }
  }, [_c('b', [_vm._v("Insurance premiums")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-857"
    }
  }, [_vm._v("—Net payment made for insurance and related costs and expenses, including deductibles paid in the event of loss.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-857"
    }
  }, [_c('b', [_vm._v("Legal expenses")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-858"
    }
  }, [_vm._v("—Costs paid for attorney’s fees, litigation, or investigation, including costs related to mediation and settlements, not including legal fees related to matters of the individual parties.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-858"
    }
  }, [_c('b', [_vm._v("Taxe")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-859"
    }
  }, [_c('b', [_vm._v("s")]), _vm._v("—Paid for the benefit of the operation (not including income taxes, VAT, and royalty to be paid by the individual parties).")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-859"
    }
  }, [_c('b', [_vm._v("Energy expenses")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-860"
    }
  }, [_vm._v("—Cost of fuel, electricity, heat, water, or other energy used and consumed for the operations.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-860"
    }
  }, [_c('b', [_vm._v("Offices")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-861"
    }
  }, [_vm._v("—Costs associated with maintaining and operating offices, camps, warehouses, housing, and other facilities directly serving operations in the country.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-861"
    }
  }, [_c('b', [_vm._v("Communication charges")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-862"
    }
  }, [_vm._v("—Costs of acquiring, leasing, installing, operating, repairing, and maintaining communication systems.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-862"
    }
  }, [_c('b', [_vm._v("Ecological and environmental protection")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-863"
    }
  }, [_c('b', [_vm._v(" charges")]), _vm._v("—Costs associated with measures undertaken to comply with statutory regulations imposed by local authorities, etc.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-863"
    }
  }, [_c('b', [_vm._v("Technical service charges")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-864"
    }
  }, [_vm._v("—Charges paid for services, such as rock specimen analysis, oil quality tests, geological evaluation, data processing, design and engineering, well site geology, drilling supervision, special research programs, and other technical services.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-864"
    }
  }, [_c('b', [_vm._v("Damages and losses")]), _vm._v("—Costs related to the repair or replacement of assets resulting from damages or losses incurred by theft, fire, flood, storm, or any other force majeure causes.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-864"
    }
  }, [_c('b', [_vm._v("Personnel training")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-865"
    }
  }, [_vm._v("—Costs incurred for personnel training.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-865"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_c('b', [_vm._v("Overhead")]), _vm._v("—Cost of indirect managerial and operational services provided by the operator’s home office, including management, administration, accounting, treasury, human resources, tax, legal, and employee relations.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-040"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-865"
    }
  }, [_vm._v("Overhead")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-865"
    }
  }, [_vm._v("Overhead is typically permitted in order to allow companies to recoup a portion of their home office costs that are necessarily incurred in order to support oil and gas operations in any given location. Examples of indirect cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-866"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-867"
    }
  }, [_vm._v("s include the cost of laboratories to process G&G or engineering data, human relations, and accounting. Overhead rates are often used as a means of avoiding complicated, multi-level cost allocations of indirect costs to specific properties. Overhead rates are often sliding-scale type rates that often vary between the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-868"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-869"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-870"
    }
  }, [_vm._v(", and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-871"
    }
  }, [_vm._v(" phases. Exploration and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-872"
    }
  }, [_vm._v(" phase overhead is illustrated in the following example.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-013"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-872"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-872"
    }
  }, [_vm._v("Overhead Rates")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-873"
    }
  }, [_vm._v(" for Exploration Operations")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-007"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-873"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab46.jpg"
    }
  })])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-041"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-873"
    }
  }, [_vm._v("Ownership of Equipment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-874"
    }
  }, [_vm._v(" and Materials")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-874"
    }
  }, [_vm._v("A common feature of PSCs relates to government ownership of equipment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-875"
    }
  }, [_vm._v(" and facilities. Typically, the ownership of all oil and gas equipment and facilities passes to the government often through the state-owned oil company. The timing")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-876"
    }
  }, [_vm._v(" of the transfer of ownership varies from one agreement to another. Sometimes ownership passes upon delivery of the equipment into the country; sometimes ownership passes when the equipment is installed; or sometimes ownership passes when the contractor has recovered the costs of the equipment and facilities. Equipment and facilities that are owned by service companies or subcontractors or equipment that is brought into the country temporarily, such as leased equipment, does not become the property of the host government.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-014"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-876"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-876"
    }
  }, [_vm._v("Contract Language Defining Ownership of Equipment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-877"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-878"
    }
  }, [_vm._v(" and Materials")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-878"
    }
  }, [_vm._v("All equipment and material purchased, installed, and constructed under the work program for each field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-879"
    }
  }, [_vm._v(" within the contract area shall be owned by the state oil com"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("pany from the date on which all the development")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-880"
    }
  }, [_vm._v(" costs actually incurred by the Contractor have been fully recovered or from the date on which the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-881"
    }
  }, [_vm._v(" period expires, even though the aforesaid costs have not been fully recovered.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-042"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-881"
    }
  }, [_vm._v("Taxes")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-882"
    }
  }, [_vm._v(" Paid-on-Behalf")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-882"
    }
  }, [_vm._v("Some PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-883"
    }
  }, [_vm._v("s include provisions that call for the state-owned oil company to pay the contractor’s local income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-884"
    }
  }, [_vm._v(" to the government on its behalf. These provisions are referred to as"), _c('b', [_vm._v(" paid-on-behalf")]), _vm._v(" (POB) provisions. It is sometimes argued that paid-on-behalf provisions")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-885"
    }
  }, [_vm._v(" provide a form of economic stabilization in that the host government would be less likely to enact new income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-886"
    }
  }, [_vm._v(" legislation or to increase existing income taxes since the state-owned oil company is paying the income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-887"
    }
  }, [_vm._v(" on behalf of the contractor. This argument is somewhat less convincing in situations where the state oil company is 100% owned and controlled by the government since such tax payments are simply transfers from one government entity to another.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-887"
    }
  }, [_vm._v("In most situations, paid-on-behalf provisions")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-888"
    }
  }, [_vm._v(" are considered as being a benefit to the contractor since such tax payments may provide certain tax benefits, such as foreign tax credits, in computing their home-country income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-889"
    }
  }, [_vm._v(" liability. The following example includes contract language where the paid-on-behalf provision"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-890"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-890"
    }
  }, [_vm._v(" results in additional revenue for the contractor, requiring that the taxes paid be grossed up to reflect the additional revenue.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-015"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-890"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-890"
    }
  }, [_vm._v("Contract Language Defining Payment of Taxes")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-891"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-891"
    }
  }, [_vm._v("The government shall assume and pay on behalf of the contractor all income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-892"
    }
  }, [_vm._v("es and any other taxes or levies measured based upon income or profits. Taxable income shall include the contractor’s gross income, including any taxes paid by the government on its behalf, less the deductions allowed under the income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-893"
    }
  }, [_vm._v(" laws of the country. For purposes of applying this article, the gross income of the contractor shall include:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-893"
    }
  }, [_vm._v("The sums received by the contractor from the sale or other disposition of all petroleum acquired by the contractor pursuant to this contract and")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-893"
    }
  }, [_vm._v("The amount of any income taxes paid by the government (or by the state oil company) on the contractor’s behalf pursuant to this article.")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-893"
    }
  }, [_vm._v("The government shall, in a timely manner, provide official receipts to the contractor for any and all income taxes paid on the contractor’s behalf.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-893"
    }
  }, [_vm._v("In this example, the taxes paid-on-behalf provision")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-894"
    }
  }, [_vm._v(" indicates that the taxes paid by the government on behalf of the contractor are to be included in the gross "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("income of the contractor. This means the contractor’s tax calculation")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-895"
    }
  }, [_vm._v(" not only includes its gross income from sales of oil and gas but also includes the tax that is paid on its behalf. This effectively results in a tax on the tax. For example, if the tax rate is 40% and taxable income is $100,000 then the tax would be $40,000. However, since the $40,000 tax paid on the contractor’s behalf is to be included in its gross income, the $40,000 tax itself becomes taxable. Thus, an additional tax of $16,000 ($40,000 x 40%) would be due. However, again, since the $16,000 in additional tax would be paid on the contractor’s behalf, it too becomes taxable resulting in an additional $6,400 ($16,000 x40%) of taxes that would be due. In order to determine the final amount of total taxes due, this process would be repeated until the incremental tax after each calculation is near zero. Alternatively, the final tax figure can be computed through a process referred to as “gross up.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-895"
    }
  }, [_vm._v("First the grossed-up income would be determined. To do this it is necessary to divide the taxable income by one minus the tax rate:")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-895"
    }
  }, [_vm._v(" $100,000 ÷ (1- 0.40) = $166,667")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-895"
    }
  }, [_vm._v("The grossed-up income is then multiplied by the tax rate in order to determine the tax.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-895"
    }
  }, [_vm._v("$166,667 x 40% = $66,667")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-895"
    }
  }, [_vm._v("This clause may be agreeable to the contractor in instances where the tax paid in the foreign country is credited against the contractor’s home country income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-896"
    }
  }, [_vm._v(".")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-043"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-896"
    }
  }, [_vm._v("PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-897"
    }
  }, [_vm._v(" Cost Recovery Illustration")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-897"
    }
  }, [_vm._v("The following simple example illustrates the overall determination of the parties’ share of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-898"
    }
  }, [_vm._v(" and reserves under a production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-899"
    }
  }, [_vm._v(" sharing contract.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-016"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-899"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-899"
    }
  }, [_vm._v("PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-900"
    }
  }, [_vm._v(" Cost Recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-901"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-901"
    }
  }, [_vm._v("Huge Oil Company, a U.S. company, is involved in petroleum operations in Country X under a production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-902"
    }
  }, [_vm._v(" sharing contract. Huge Oil Company has a 49% working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-903"
    }
  }, [_vm._v(" and Able Company, the state-owned oil company, has a 51% working interest. The contract specifies that annual gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-904"
    }
  }, [_vm._v(" is to be divided in the following order:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-904"
    }
  }, [_vm._v("Royalty is 10% of gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-905"
    }
  }, [_vm._v(" and is to be paid in kind.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-905"
    }
  }, [_vm._v("VAT")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-906"
    }
  }, [_vm._v(" is equal to 6% of gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-907"
    }
  }, [_vm._v(" and is to be paid in kind.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-907"
    }
  }, [_vm._v("Cost oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-908"
    }
  }, [_vm._v(" is limited to 60% of gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-909"
    }
  }, [_vm._v(". Costs are to be recovered in the following order:")])]), _c('ol', {
    staticClass: "liste_alpha"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-909"
    }
  }, [_vm._v("Operating expenses")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-910"
    }
  }, [_vm._v("—paid based on working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-911"
    }
  }, [_vm._v(" share (49% by Huge Oil Company and 51% by Able Company)")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-911"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("Exploration and appraisal")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-912"
    }
  }, [_vm._v(" costs—paid 100% by Huge Oil Company")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-912"
    }
  }, [_vm._v("Development costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-913"
    }
  }, [_vm._v("—paid based on working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-914"
    }
  }, [_vm._v(" share (49% by Huge Oil Company and 51% by Able Company)")])])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-914"
    }
  }, [_vm._v("Any excess production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-915"
    }
  }, [_vm._v(" remaining after cost recovery")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-916"
    }
  }, [_vm._v(" becomes profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-917"
    }
  }, [_vm._v(" and is to be divided as follows:")])]), _c('ol', {
    staticClass: "liste_alpha"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-917"
    }
  }, [_vm._v("The government receives 15% of profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-918"
    }
  }, [_vm._v(".")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-918"
    }
  }, [_vm._v("The remaining profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-919"
    }
  }, [_vm._v(" is divided between Huge Oil Company and Able Company based on their working interests.")])])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-919"
    }
  }, [_vm._v("For 2025 assume that:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-919"
    }
  }, [_vm._v("Recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-920"
    }
  }, [_vm._v(" operating costs total $9,000,000")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-920"
    }
  }, [_vm._v("Exploration and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-921"
    }
  }, [_vm._v(" costs (unrecovered to date) total $150,000,000")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-921"
    }
  }, [_vm._v("Development costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-922"
    }
  }, [_vm._v(" (unrecovered to date) total $210,000,000")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-922"
    }
  }, [_vm._v("The annual gross production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-923"
    }
  }, [_vm._v(" for the year is 4,000,000 barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-924"
    }
  }, [_vm._v(" of oil")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-924"
    }
  }, [_vm._v("The agreed upon price is $30 per barrel")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-924"
    }
  }, [_vm._v("In order to convert the costs into barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-925"
    }
  }, [_vm._v(", the costs must be divided by a price per barrel. The contract will specify how the parties are to agree upon the price per barrel to be used for this purpose.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-925"
    }
  }, [_vm._v("The allocation of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-926"
    }
  }, [_vm._v(" to the parties would be as follows:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-008"
    }
  }, [_c('figure', {
    staticClass: "stab"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-926"
    }
  }, [_c('img', {
    staticClass: "stab",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab49.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-926"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("Huge Oil Company must also pay income taxes on all oil and gas operations determined in accordance with the local income taxes.")])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-044"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-926"
    }
  }, [_vm._v("Decommissioning and Abandonment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-927"
    }
  }, [_vm._v(" Costs")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-927"
    }
  }, [_vm._v("Decommissioning and abandonment costs refer to the future costs associated with the dismantlement, abandonment, restoration, and reclamation of oil and gas wells, properties, and other production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-928"
    }
  }, [_vm._v(" facilities, such as plants, pipelines, and storage facilities. The specific contract and legal requirements relating to the property determine who has the obligation to plug, decommission, remove, dismantle, and reclaim the various wells and facilities.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-928"
    }
  }, [_vm._v("Government ownership of equipment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-929"
    }
  }, [_vm._v(" and facilities raises interesting questions regarding the responsibility for future abandonment and reclamation costs. In addition, as indicated above, typically the PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-930"
    }
  }, [_vm._v(" production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-931"
    }
  }, [_vm._v(" phase spans a contractually determined number of years. Such a provision makes it possible if not likely that the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-932"
    }
  }, [_vm._v(" phase will end prior to the actual physical end of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-933"
    }
  }, [_vm._v(". When this is the case, the state-owned oil company typically takes over operations at the end of the contractual production period. Given these provisions, some PSCs in the past have not addressed decommissioning and abandonment costs. The presumption is that since the state-owned oil company owns the equipment and will typically own 100% of the working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-934"
    }
  }, [_vm._v(" at the actual physical end of production, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("the state-owned oil company will be responsible for paying decommissioning and abandonment costs. Furthermore, even if the contractor were still a working interest owner")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-935"
    }
  }, [_vm._v(" when production ceased, there would be no opportunity for the contractor to recover its share of decommissioning and abandonment costs.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-935"
    }
  }, [_vm._v("More recently PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-936"
    }
  }, [_vm._v("s include language requiring all working interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-937"
    }
  }, [_vm._v(" owners involved in a production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-938"
    }
  }, [_vm._v(" operation to deposit money into an abandonment fund")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-939"
    }
  }, [_vm._v(" to be used in the future to pay for abandonment and reclamation, thus assuring that money will be available to actually pay for decommissioning and abandonment operations. Some contracts require payment into the fund throughout the entire production period while other contracts require that deposits commence at some point, e.g., after all development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-940"
    }
  }, [_vm._v(" costs have been recovered. Payments into abandonment funds may be recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-941"
    }
  }, [_vm._v(". After decommissioning and abandonment is completed, the government typically owns any excess money in the fund.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-017"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-941"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-941"
    }
  }, [_vm._v("Contract Language Requiring Payment into Abandonment Fund")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-942"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-942"
    }
  }, [_vm._v("Upon preparation of a development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-943"
    }
  }, [_vm._v(" plan for any field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-944"
    }
  }, [_vm._v(" in the contract area, the contractor shall likewise prepare an abandonment plan for said field, including an itemized cost estimate for implementation of the abandonment plan. The itemized cost estimate is to include a realistic estimate of the costs to be incurred at the time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-945"
    }
  }, [_vm._v(" of the actual abandonment operations. No later than the commencement of production, the contractor shall prepare a yearly production forecast profile for each field in barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-946"
    }
  }, [_vm._v(" of crude oil, cubic feet of natural gas, and barrels of oil equivalent.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-946"
    }
  }, [_vm._v("When production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-947"
    }
  }, [_vm._v(" from any field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-948"
    }
  }, [_vm._v(" commences, payment into the field abandonment fund")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-949"
    }
  }, [_vm._v(" shall be determined based on the following formula:")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-949"
    }
  }, [_vm._v("Annual Abandonment Fund Payments =")])]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fonctionp51"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-949"
    }
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/fonctionp51.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-949"
    }
  }, [_vm._v("The contractor shall review and revise cost and reserve estimates")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-950"
    }
  }, [_vm._v(" on an annual basis and revise the formula values accordingly.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-950"
    }
  }, [_vm._v("Abandonment cost payments made by the contractor shall be cost recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-951"
    }
  }, [_vm._v(".")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-045"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-951"
    }
  }, [_vm._v("Other Terms and Fiscal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-952"
    }
  }, [_vm._v(" Incentives")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-952"
    }
  }, [_vm._v("Local governments want the foreign contractors to explore, drill, and produce oil or gas as soon as possible. Consequently, governments often provide incentives to companies in an effort to maximize the amount of money the foreign companies will invest in exploration"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-953"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-953"
    }
  }, [_vm._v(", drilling, and development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-954"
    }
  }, [_vm._v(". These incentives may be specified in the contract or result from other negotiations and agreements.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-046"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-954"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Capital uplift")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-954"
    }
  }, [_vm._v("A capital uplift")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-955"
    }
  }, [_vm._v(", also referred to as an"), _c('b', [_vm._v(" investment credit")]), _vm._v(", occurs when a company is allowed to recover costs in excess of the amount the company actually spent for development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-956"
    }
  }, [_vm._v(" and sometimes for exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-957"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-958"
    }
  }, [_vm._v(". For example, if there is a 12% capital uplift in the contract and if a contractor has spent $500,000,000 in recoverable")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-959"
    }
  }, [_vm._v(" development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-960"
    }
  }, [_vm._v(" costs, the contractor can recover 112% of actual development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-961"
    }
  }, [_vm._v(" expenditures or $560,000,000.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-047"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-961"
    }
  }, [_vm._v("Ringfencing")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-962"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-962"
    }
  }, [_vm._v("Often a question arises as to whether costs incurred in one location are recoverabl")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-963"
    }
  }, [_vm._v("e against production in another location. Typically, only costs spent in a particular contract area or field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-964"
    }
  }, [_vm._v(" are recoverable from production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-965"
    }
  }, [_vm._v(" in that same contract area or field. This restriction is referred to as ringfencing. For example, assume that a particular contractor has two licenses in two different contract areas. Assume further that in one contract area there is a field that has been producing for some time, and the other contract area is still in the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-966"
    }
  }, [_vm._v(" and appraisal phase. If there is ringfencing then the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-967"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-968"
    }
  }, [_vm._v(" costs from the second contract area are not recoverable against production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-969"
    }
  }, [_vm._v(" from the field in the other contract area.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-969"
    }
  }, [_vm._v("Sometimes, as an incentive the governments may lift the ringfencing requirement and permit the contractor cross fence recovery of costs. This would, at least theoretically, permit the contractor to recover costs more quickly and often is used as an incentive to encourage the contractor to undertake exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-970"
    }
  }, [_vm._v(" that it might not otherwise find economically attractive.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-048"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-970"
    }
  }, [_vm._v("Domestic market obligations")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-971"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-971"
    }
  }, [_vm._v("Some contracts specify that a certain percentage of the contractor’s share of profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-972"
    }
  }, [_vm._v(" be sold in the local market. This requirement is referred to as the domestic market obligation and is often included in situations where the demand for crude oil in the country is greater than the government’s share of production. Sometimes the price that the contractor can charge for the oil is equal to the current market price, and sometimes the contract establishes a maximum price that may actually be below the market price that the contractor could have received if the domestic market obligation had not existed.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-049"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-972"
    }
  }, [_vm._v("Royalty holiday")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-973"
    }
  }, [_vm._v("s and tax holiday")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-974"
    }
  }, [_vm._v("s")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-974"
    }
  }, [_vm._v("Royalty holidays and tax holidays are incentives often granted in the early life of a contract. The government may wish to provide an incentive to encourage higher investment in the country by specifying a particular period of time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-975"
    }
  }, [_vm._v(" during which the royalty provision")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-976"
    }
  }, [_vm._v(" is waived. This incentive, which is referred to as a royalty "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("holiday, provides the contractor with a “holiday” or temporary reprieve from the payment of royalties")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-977"
    }
  }, [_vm._v(". It also leaves the contractor with more money to reinvest in additional drilling and development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-978"
    }
  }, [_vm._v(". Therefore, the holiday benefits both the government and the contractor. Similarly, the government may exempt the contractor from payment of income taxes or petroleum taxes during a specified period of time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-979"
    }
  }, [_vm._v(". This is referred to as a tax holiday. The government’s goal in granting either royalty or tax holidays is to encourage contractors to maximize investment early in the life of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-980"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-980"
    }
  }, [_vm._v("These are just a few of the most popular terms or provisions that may appear in PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-981"
    }
  }, [_vm._v("s. A discussion of all of the possible terms and variations would obviously be too lengthy to include in this chapter.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-981"
    }
  }, [_vm._v("Service Agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-982"
    }
  }, [_vm._v("s")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-982"
    }
  }, [_vm._v("Another agreement common in production/profit sharing systems")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-983"
    }
  }, [_vm._v(" is a risk-service agreement. In a risk-service agreement, the contractor pays all of the costs and assumes all of the risks related to exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-984"
    }
  }, [_vm._v(", appraisal, development, and production activities. If production is attained, the contractor is in return allowed to recoup its costs as production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-985"
    }
  }, [_vm._v(" is sold and in addition receives a fee typically based on production for its services. Risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-986"
    }
  }, [_vm._v(" were originally used primarily in situations where a field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-987"
    }
  }, [_vm._v(" had been in production but was in need of rejuvenation. The service provided by the oil and gas producer was to apply current technology and investment to get the field back up to its maximum economic potential. Due to the prior production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-988"
    }
  }, [_vm._v(" history, the risks encountered were primarily related to operational risks. In more recent years, risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-989"
    }
  }, [_vm._v(" have been used in higher risk situations involving exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-990"
    }
  }, [_vm._v(" as well as development and production.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-990"
    }
  }, [_vm._v("Risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-991"
    }
  }, [_vm._v(" have many terms and features that are similar to PSCs. For example, the contractor pays a signature bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-992"
    }
  }, [_vm._v(" and the government receives a royalty interest")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-993"
    }
  }, [_vm._v(". Through a state-owned oil company, the government may be involved in the operation typically with the option to participate after the contractor has incurred the costs and risks associated with exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-994"
    }
  }, [_vm._v(" and appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-995"
    }
  }, [_vm._v(", and an operating committee is normally formed. Risk-service agreements differ from PSCs primarily in that the payment to the contractor is in the form of a fee rather than involving recovery of cost oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-996"
    }
  }, [_vm._v(" and profit oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-997"
    }
  }, [_vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-997"
    }
  }, [_vm._v("Like PSCs, risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-998"
    }
  }, [_vm._v(" are generally proprietary; therefore, reprinting one in this book is not feasible. Since the terms of risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-999"
    }
  }, [_vm._v(" vary, no one single sample contract could contain all of the clauses and provisions actually found in practice. Some of the provisions frequently appearing in risk-service agreements (other than the basic provisions such as bonuses and royalties")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1000"
    }
  }, [_vm._v(" that have been previously discussed) are described below along with an example of many of the key provisions.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-050"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1000"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Limitations on Length of Contractor Participation")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1000"
    }
  }, [_vm._v("Like PSCs, most risk-service agreements"), _c('b')]), _c('b', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1001"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1001"
    }
  }, [_vm._v(" limit the term of the agreement. If production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1002"
    }
  }, [_vm._v(" continues after the end of the contract term, the state-owned oil company typically takes over the operations.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-018"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1002"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1002"
    }
  }, [_vm._v("Contract Language Describing Maximum Contract Life")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1003"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1003"
    }
  }, [_vm._v("This agreement shall be in effect for twenty years from the effective date of the contract. In the event there is no production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1004"
    }
  }, [_vm._v(" during the first four years after execution, the agreement shall immediately fully cease, except as otherwise provided therein.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-051"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1004"
    }
  }, [_vm._v("Rehabilitation")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1004"
    }
  }, [_vm._v("Frequently risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1005"
    }
  }, [_vm._v(" relate to activities that are directed toward the rehabilitation of existing fields. Such agreements may be necessary because perhaps the local government lacks the financial or technological resources to maintain optimal levels of output after several years of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1006"
    }
  }, [_vm._v(". Because a field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1007"
    }
  }, [_vm._v(" may be nearing the final phase of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1008"
    }
  }, [_vm._v(", any provisions of the agreement that specify which party is to be responsible for decommissioning and site restoration are of considerable importance. A common practice is to call for a baseline environmental study to establish any pre-existing environmental conditions so that the contractor is only responsible for any remediation that is required as a consequence of operations that occurred after execution of the contract.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-019"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1008"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1008"
    }
  }, [_vm._v("Contract Language Describing Environmental Baseline Studies")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1009"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1009"
    }
  }, [_vm._v("The parties agree to commission and evaluation and audit")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1010"
    }
  }, [_vm._v(" of the environmental conditions existing in the contract area within one month of the effective date of the contract. The cost of the evaluation")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1011"
    }
  }, [_vm._v(" is to be shared equally by the parties. The Contractor shall not be liable for the preexisting environmental conditions.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-052"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1011"
    }
  }, [_vm._v("Ownership of Minerals")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1012"
    }
  }, [_vm._v(" and Production")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1012"
    }
  }, [_vm._v("One interesting feature of risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1013"
    }
  }, [_vm._v(" is that ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1014"
    }
  }, [_vm._v(" of reserves, resources, and production by the contractor is not permitted. Such provisions provide difficulties to accountants in determining whether any reserves attributable to the contract are to be included in the contractor’s financial statement disclosures")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1015"
    }
  }, [_vm._v(". Estimation and reporting of reserves information is discussed in detail in ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(".")]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-020"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("EXAMPLE")]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_vm._v("Contract Language Describing Ownership of Minerals"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1016"
    }
  }, [_vm._v(" and Production")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1016"
    }
  }, [_vm._v("All hydrocarbons existing within the national territory are a resource owned and controlled by the State. The government wishes to promote the development and production of oil")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1017"
    }
  }, [_vm._v(". The Contractor agrees to render services within the country and agrees that its compensation for the services hereunder shall include only cash payments based on production levels achieved but shall not include any title to the oil or gas found or produced in the contract area.")])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-053"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1017"
    }
  }, [_vm._v("Minimum Work Commitment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1018"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1018"
    }
  }, [_vm._v("Like PSCs, many risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1019"
    }
  }, [_vm._v(" provide for minimum amounts that must be spent by the contractor in providing the contracted services.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-021"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1019"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1019"
    }
  }, [_vm._v("Contract Language Describing Minimum Work Commitment")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1020"
    }
  }), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1021"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1021"
    }
  }, [_vm._v("The total amount to be spent by the Contractor to perform the operations during the first thirty-six months, as provided herein, shall not, in the aggregate, be less than the amount specified below for each one of these three periods of twelve months:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-010"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("First twelve (12) months")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("$15,000,000")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Second twelve (12) months")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("$18,000,000")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Third twelve (12) months")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("$20,000,000")])])])])])])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-054"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1021"
    }
  }, [_vm._v("Operating Costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1022"
    }
  }, [_vm._v(" versus Capital Costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1023"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1023"
    }
  }, [_vm._v("Risk-service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1024"
    }
  }, [_vm._v(" often calculate the fee paid to the contractor based on operating and capital costs actually incurred. The distinction between capital and operating costs is not based on the traditional distinction that accountants are accustomed to using in their accounting practice. Rather the contractual definition of operating versus capital costs must be used to determine how any particular cost is to be classified. Obviously, the contract definition would be required for contract accounting purposes while a different definition would likely be required for financial accounting")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1025"
    }
  }, [_vm._v(", particularly since some companies use the full cost-method")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1026"
    }
  }, [_vm._v(" while others use successful efforts")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1027"
    }
  }, [_vm._v(" in determining how costs are to be classified.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-022"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1027"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1027"
    }
  }, [_vm._v("Contract Language Describing Operating versus Capital Costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1028"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1028"
    }
  }, [_c('span', {
    staticClass: "sl"
  }, [_c('b', [_vm._v("Operating Costs")])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1029"
    }
  }, [_vm._v(": Operating costs include:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1029"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_vm._v("Labor, materials")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1030"
    }
  }, [_vm._v(", and services used in daily oil operations, storage, handling, transportation, and processing operations, measurement, and other operational activities, including surface and subsurface equipment repair and maintenance")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1030"
    }
  }, [_vm._v("General administration of main and field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1031"
    }
  }, [_vm._v(" offices")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1032"
    }
  }, [_vm._v(" in the country, general services including technical and related services, tangible services, transport, lease of special or heavy equipment, personnel expenses, public relations, and other expenses incurred abroad")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1032"
    }
  }, [_vm._v("Facilities having a life of less than one year")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1032"
    }
  }, [_vm._v("All technical")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1033"
    }
  }, [_vm._v(" or managerial costs other than those specifically included as capital costs")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1033"
    }
  }, [_c('span', {
    staticClass: "sl"
  }, [_c('b', [_vm._v("Capital Costs:")])]), _vm._v(" Capital cost")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1034"
    }
  }, [_vm._v("s include: those reasonable and necessary disbursements, actually made by the contractor, for items that usually have a useful life beyond the year they are incurred, provided they are included in the budget. This includes any drilling costs.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-055"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1034"
    }
  }, [_vm._v("Compensation—the Fee")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1035"
    }
  })]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1035"
    }
  }, [_vm._v("The amount of compensation, or the fee, that is paid to the contractor is typically based on three factors: the operating costs incurred, the capital costs incurred, and a profit factor. Capital costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1036"
    }
  }, [_vm._v(" are typically defined as being any costs spent on drilling, equipment, and other purchases that have an expected life of more than a year at the time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1037"
    }
  }, [_vm._v(" of the expenditure. Costs that are incurred for current production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1038"
    }
  }, [_vm._v(" or for items with an expected life shorter than a year are typically classified as operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1039"
    }
  }, [_vm._v(". Operating costs are typically fully paid or recovered in the year they are incurred. Capital costs are typically reimbursed to the contractor over a number of years. The profit component of the fee is usually based on the level of production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1040"
    }
  }, [_vm._v(" achieved. As such, the incentive payments become larger as production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1041"
    }
  }, [_vm._v(" levels increase.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-023"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1041"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1041"
    }
  }, [_vm._v("Contract Language Describing Compensation")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1042"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1042"
    }
  }, [_vm._v("Each year, the contractor shall be compensated")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1043"
    }
  }, [_vm._v(" on the basis of the gross volume of oil and gas delivered to the state oil company. The annual fee for services performed shall include all operating costs plus 1/10 of all capital costs (as defined in this agreement) expended plus incentive payments to the contractor, the amount of which depends on the level of production achieved.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-056"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1043"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Ownership of Assets")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1043"
    }
  }, [_vm._v("As with PSCs, any material, equipment, or facilities brought into the country by the contractor, for other than temporary use, become the property of the local government (through the state-owned oil company). Typically, title or ownership")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1044"
    }
  }, [_vm._v(" of material, equipment, and facilities passes to the government when the cost of the material, equipment, and facilities has been reimbursed (in the form of capital fees to the contractor). In some cases, however, the title or ownership of the equipment and facilities may pass to the government at the time")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1045"
    }
  }, [_vm._v(" the equipment or materials are brought into the country.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-024"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1045"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1045"
    }
  }, [_vm._v("Contract Language Describing Ownership of Assets")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1046"
    }
  })]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1046"
    }
  }, [_vm._v("All assets purchased, installed, and constructed under the work program and budget for each oil field")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1047"
    }
  }, [_vm._v(" or gas field in the contract area are to be owned by the state oil company from the date on which all the development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1048"
    }
  }, [_vm._v(" costs actually incurred by the contractor have been fully recovered or from the date on which the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1049"
    }
  }, [_vm._v(" period expires, even though the aforesaid costs have not been fully recovered.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1049"
    }
  }, [_vm._v("The following simple example illustrates the overall determination of the parties’ share of production under a risk-service agreement.")])]), _c('div', {
    staticClass: "niv3",
    attrs: {
      "id": "niv3-025"
    }
  }, [_c('h4', {
    staticClass: "int_niv3",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1049"
    }
  }, [_vm._v("EXAMPLE")])]), _c('h4', {
    staticClass: "sint_niv3",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1049"
    }
  }, [_vm._v("Risk-service Agreement")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1049"
    }
  }, [_vm._v("Huge Oil Company signed a risk-service agreement with the government of Country X, paying a $2,000,000 signature bonus")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1050"
    }
  }, [_vm._v(". Huge Oil Company must pay all exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1051"
    }
  }, [_vm._v(", development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1052"
    }
  }, [_vm._v(", and production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1053"
    }
  }, [_vm._v(" costs. Per the contract, all costs incurred in the exploration")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1054"
    }
  }, [_vm._v(", appraisal")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1055"
    }
  }, [_vm._v(", and development")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1056"
    }
  }, [_vm._v(" phases of each project area are capital costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1057"
    }
  }, [_vm._v(" (CAPEX) and all costs incurred in the production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1058"
    }
  }, [_vm._v(" phase are operating costs")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1059"
    }
  }, [_vm._v(" (OPEX).")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1059"
    }
  }, [_vm._v("Each year in which production occurs the government must pay Huge Oil Company a fee consisting of the following:")])]), _c('ol', {
    staticClass: "liste_num"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1059"
    }
  }, [_vm._v("All OPEX incurred in the current year")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1059"
    }
  }, [_vm._v("1/10th of all unrecovered CAPEX, and")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1059"
    }
  }, [_vm._v("$0.50 per barrel")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1060"
    }
  }, [_vm._v(" on production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1061"
    }
  }, [_vm._v(" from 0 to 6,000 barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1062"
    }
  }, [_vm._v(" per day")])]), _c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1062"
    }
  }, [_vm._v("$0.80 per barrel on production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1063"
    }
  }, [_vm._v(" from 6,001 to 13,000 barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1064"
    }
  }, [_vm._v(" per day")])]), _c('p', {
    staticClass: "liste_txt_courant_gauche"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1064"
    }
  }, [_vm._v("$1.00 per barrel on production")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1065"
    }
  }, [_vm._v(" above 13,000 barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1066"
    }
  }, [_vm._v(" per day")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1066"
    }
  }, [_vm._v("The maximum total fee that may be paid in any year is $1.50 per barrel times the total number of barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1067"
    }
  }, [_vm._v(" produced. Any unrecovered OPEX or CAPEX (unrecovered due to the maximum fee) is to be carried forward to future years.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1067"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  }, [_vm._v("Production begins in 2025. As of the end of the year, Huge Oil Company has spent $15,000,000 on CAPEX and $4,000,000 on OPEX. Production during the year is 5,000,000 barrels")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1068"
    }
  }, [_vm._v(" or 5,000,000/365 = 13,699 barrels per day.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1068"
    }
  }, [_vm._v("Huge Oil Company’s fee for 2025 would be calculated as follows:")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-011"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "69%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("OPEX")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("$4,000,000")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("CAPEX ($15,000,000/10)")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,500,000")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("6,000 x 365 days $.50")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("1,095,000")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("7,000 x 365 days $.80")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_vm._v("2,044,000")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("699 x 365 days $1")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('span', {
    staticClass: "sl"
  }, [_vm._v("255,135")])])])]), _c('tr', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Total fee")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('span', {
    staticClass: "sl"
  }, [_vm._v("$8,894,135")])])])])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1068"
    }
  }, [_vm._v("The total fee per barrel is calculated as follows:")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1068"
    }
  }, [_vm._v("$8,894,135/5,000,000 barrels")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1069"
    }
  }, [_vm._v(" = "), _c('span', {
    staticClass: "sl"
  }, [_vm._v("$1.7788")]), _vm._v(" per barrel")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1069"
    }
  }, [_vm._v("The $1.7788 fee per barrel is greater than the maximum fee of $1.50 per barrel; therefore, the actual fee Huge Oil Company receives is:")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1069"
    }
  }, [_vm._v("$1.50 x 5,000,000 = "), _c('span', {
    staticClass: "sl"
  }, [_vm._v("$7,500,000")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1069"
    }
  }, [_vm._v("The difference between the calculated fee of $8,894,135 and the maximum fee of $7,500,000 is $1,394,135.That amount is considered to be unrecovered CAPEX and is carried forward to the next year.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1069"
    }
  }, [_vm._v("Huge Oil Company is also liable for income taxes on all of its oil and gas operations in accordance with the local income tax")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1070"
    }
  }, [_vm._v(" laws.")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1070"
    }
  }, [_vm._v("Joint Operating Agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1071"
    }
  }, [_vm._v("s")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1071"
    }
  }, [_vm._v("When two or more companies are involved in a joint operation, they must execute some type of joint operating agreement")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1072"
    }
  }, [_vm._v(". The specific government contract, e.g., concession, PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1073"
    }
  }, [_vm._v(", or service agreement, provides the basis for all subsequent contracts and agreements, including joint operating agreements. Sometimes PSCs and service agreements")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1074"
    }
  }, [_vm._v(" are comprehensive enough that it is the only contract needed. When more than one foreign company is involved as the contractor, the PSC")]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1075"
    }
  }, [_vm._v(" or service agreement may serve as the operating agreement between the state-owned oil company and the contractor with a separate joint operating agreement being executed between the foreign companies. Joint operating agreements are discussed in detail in ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap13#chap-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 13")]), _vm._v(". An AIPN model form Joint Operating Agreement"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1076"
    }
  }, [_vm._v(" is in Appendix A, and an AIPN model form International Accounting Procedure is in ")]), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/appen3#appen-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B")]), _vm._v(".")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59",
      "title": "59"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Summary")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This chapter describes the overall nature and some of the specific requirements of the major types of contracts"), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1077"
    }
  }, [_vm._v(" encountered in worldwide operations. The following chart highlights the similarities and differences between the various contracts. Keep in mind that because contracts are a result of negotiations between parties, anything is possible.")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-012"
    }
  }, [_c('figure', {
    staticClass: "stablarge"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1077"
    }
  }, [_c('img', {
    staticClass: "stablarge",
    attrs: {
      "alt": "Tableau",
      "src": "images/tab59.jpg"
    }
  })])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1077"
    }
  }, [_vm._v("Reserve"), _c('i')]), _c('i', [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1078"
    }
  })]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1078"
    }
  }, [_vm._v(" reporting and financial accounting requirements will be discussed in detail in the next several chapters.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-057"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1078"
    }
  }, [_vm._v("References")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-004"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1078"
    }
  }, [_vm._v("Johnston, Daniel."), _c('i', [_vm._v(" International Petroleum Fiscal Systems and Production Sharing Contracts")])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1079"
    }
  }, [_c('i', [_vm._v(".")]), _vm._v(" PennWell Publishing, Tulsa, OK: 1994.")])]), _c('p', {
    staticClass: "pbib",
    attrs: {
      "id": "pbib-005"
    }
  }, [_c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1079"
    }
  }, [_vm._v("Tordo, Silvana."), _c('i', [_vm._v(" Fiscal Systems for Hydrocarbons: Design Issues")]), _vm._v(". World Bank Working Paper no. 123. The World Bank, Washington DC: 2007.")])])])])])])])]), _c('a', {
    staticClass: "indx",
    attrs: {
      "id": "indx-1079"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 72
// module chunks = 0